import { Injectable/*,Injector*/ } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

//import {AuthProvider} from '../../providers/auth/auth';

import { Events } from 'ionic-angular';

import { DomainEvents, Device } from '../../models/models';

/*
	Inietta identifier del dispositivo attuale
	*/
@Injectable()
export class IdentifierInterceptor implements HttpInterceptor {
	private identifier: string;
	private device: Device;

	constructor(
		public events: Events,
	) {
		let self = this;
		events.subscribe(DomainEvents.DEVICE_ACTUAL_IDENTIFIED, (identifier: string, _time) => {
			if (identifier) {
				self.identifier = identifier;
			}
		})

		events.subscribe(DomainEvents.DEVICE_ACTUAL_UPDATED, (device: Device, _time, _previousDevice: Device) => {
			if (device && device.id) {
				self.device = device;
			} else {
				self.device = null;
			}
		})
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (this.identifier || (this.device && this.device.id)) {
			//request = request.clone({params:request.params.append('identifier',this.identifier)});
			let headers = request.headers;
			if (this.identifier) {
				headers = headers.set('X-Device-Identifier', this.identifier);
			}
			if (this.device && this.device.id) {
				headers = headers.set('X-Device-Id', this.device.id.toString());
			}

			request = request.clone({ headers: headers });
			/*
				WORKAROUND BUG
				*/
			// Keeps the original request params. as a new HttpParams
			// Add any params (can also chain .append() but I was conditionally adding params)
			//let params = new HttpParams({fromString: request.params.toString()}).set('identifier',this.identifier);
		}

		return next.handle(request);
	}
}



// WEBPACK FOOTER //
// ./src/interceptors/identifier/identifier.ts